import { render, staticRenderFns } from "./advertisingManage.vue?vue&type=template&id=32ecb492&"
import script from "./advertisingManage.vue?vue&type=script&lang=js&"
export * from "./advertisingManage.vue?vue&type=script&lang=js&"
import style0 from "./advertisingManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports